import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { rolesView_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/rolesView_template";
import {networkGroupView_template} from "../components/templates/networkGroupView_template";

declare var ko: any;
declare var page: any;

export class networkGroup_view extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected networkGroupViewTemplate: networkGroupView_template;

    protected getModuleName(){
        return "networkGroup_view";
    }

    buildContent() : Array<Element>{
        this.networkGroupViewTemplate = new networkGroupView_template("networkGroupView_template", this.viewModel, this);

        return [this.networkGroupViewTemplate.build()];
    }

    protected backToList(): void {
        page.redirect('/network_groups');
    }

    protected editNetworkGroup(networkGroupId: number): void {
        page('/network_groups/edit/' + networkGroupId);
    }

    //
    // fill the template page with data.
    fillPage() : void{
        this.getFormData();
    }
    //
    // getting data from server by ajax call.
    public getFormData(): void {

        this.loadingIn(this.networkGroupViewTemplate.builtTemplate.children.namedItem("view-results"));
        let id: number;

        if( (id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
            this.networkGroupViewTemplate.getTemplateViewModel().idNetworkGroup(id);
        }

        let usrReq_url: string = '/api/network_groups/get/' + id + "/";
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetNetworkGroupDataReturn;
        this.XHRHdl.execute();
    }

    //
    // Handling response data
    protected onGetNetworkGroupDataReturn(req, obj): Function {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.setNetworkGroup(responseParsed);
                obj.getReferences();
            });
        }
    }

    private getReferences(): void {

        let usrReq_url: string = '/api/network_groups/references/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetReferencesDataReturn;
        this.XHRHdl.execute();
    }


    private onGetReferencesDataReturn(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.updateReferences(responseParsed);
                obj.loadingOut(obj.networkGroupViewTemplate.builtTemplate.children.namedItem("view-results"));
            });
        }
    }


    protected updateReferences(networks: Array<{id: number, name: string, description: string}>): void {

        this.networkGroupViewTemplate.setNetworks(networks);
    }

    //
    // set role on rolesView_template
    public setNetworkGroup(role: any) : void {
        this.networkGroupViewTemplate.setNetworkGroup(role);
    }
}



// WEBPACK FOOTER //
// ./js/modules/networkGroup_view.ts